import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/msv-browse-layout.css';
import './styles/msv-grid-shared.css';
import './styles/msv-detail-shared.css';
import './styles/dev-ad-outlines.css';
import App from './App';

if (process.env.NODE_ENV !== 'production') {
    document.documentElement.setAttribute('data-msv-dev-ads', '');
}

const root = ReactDOM.createRoot(document.getElementById('root'), {
    onRecoverableError(error) {
        const cause = error?.cause ?? error;
        console.error('[React recoverable error]', cause);
    },
});
root.render(
    <App />
);
